import React from 'react';
import PropTypes from 'prop-types';

import { Label, ImageUploader } from '../../../../../../../components';

const Images = (props) => {
  const { errors, onImageUploaded, imageUrl } = props;
  return (
    <div className="form-group">
      <div className="form-group-fields">
        <div className="form-group-column">
          <div className="input image-upload">
            <Label attr="image" text="Image" errors={errors} />
            <div className="image-upload-hint">
              Image should be a .png or .jpg
            </div>
            <ImageUploader
              id="image"
              onUploaded={onImageUploaded}
              cover
              source={imageUrl}
              type="setting"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Images;

Images.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape()),
  onImageUploaded: PropTypes.func.isRequired,
};

Images.defaultProps = {
  errors: [],
};
